module.exports = __webpack_public_path__ + "img/oni.963fff16.svg";